<main class="hero">
	<div class="hero-body is-paddingless">
		<div class="container">
			<div class="columns is-marginless is-multiline" style="height: 100%">
				<div class="banner-column column is-full is-relative" [style.background-image]="backgroundImage">
					<div class="banner-tag has-text-centered">
						<h1 class="title is-2 is-marginless" style="color: white">{{ bannerTagTitle }}</h1>
						<div class="tag-text-container">
							<p class="is-uppercase" style="color: white">{{ bannerTagLine1 }}</p>
							<p class="is-uppercase" style="color: white">{{ bannerTagLine2 }}</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</main>

<section class="services">
	<div class="container">
		<div class="columns">
			<div *ngFor="let item of serviceItems" class="column is-one-third-desktop service-item-container">
				<div class="service-item">
					<div class="columns is-mobile">
						<div class="column is-narrow is-flex" style="align-items: center">
							<img [src]="item.icon" />
						</div>
						<div class="column has-text-centered">
							<h4 class="title red is-4">{{ item.title }}</h4>
							<p style="font-size: 12px">{{ item.description }}</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>

<section class="areas">
	<div class="padding-sm is-hidden-touch"></div>
	<div class="padding-lg is-hidden-desktop"></div>
	<div class="container has-text-centered">
		<h3 class="title blue is-3">Industrias</h3>
		<div class="columns is-multiline is-mobile">
			<div *ngFor="let industry of industries" class="column is-one-quarter-desktop is-half-touch">
				<img [src]="industry.icon" />
				<h4 class="title blue is-4 industry-title">{{ industry.title }}</h4>
			</div>
		</div>
	</div>
</section>

<app-contact-form></app-contact-form>